import React from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';
import useWindowSize from '@hooks/useWindowSize';

import HorizontalTimePoint from './HorizontalTimePoint';
import VerticalTimePoint from './VerticalTimePoint';
import { ARTICLE_TIME_LINE_EVENTS } from './timeLineEvents';

const TimeLine = () => {
  const { width: windowWidth } = useWindowSize();
  const hydrated = useServerSideRendering();

  return (
    <div className="mx-auto flex justify-center">
      <div className="w-full px-16">
        <h3 className="mx-auto mt-48 text-center font-serif text-headline-sm font-bold sm:mt-64 sm:max-w-lg lg:max-w-none">
          Explore The Information’s reporting and the coverage that followed.
        </h3>
        {hydrated &&
          (windowWidth < 1200
            ? ARTICLE_TIME_LINE_EVENTS.map((articles, index) => (
                <>
                  <div
                    className="relative my-48 ml-80 sm:ml-[12rem]"
                    key={articles[0].articleTitle}
                  >
                    <div className="h-[350px] w-px bg-gray-300 sm:h-[405px]"></div>
                    <VerticalTimePoint articles={articles} />
                  </div>
                  {index < ARTICLE_TIME_LINE_EVENTS.length - 1 ? (
                    <div className="border-0 border-b border-solid border-gray-200 sm:mx-64"></div>
                  ) : (
                    <div className="border-0 border-b-2 border-solid border-gray-300 sm:mx-64"></div>
                  )}
                </>
              ))
            : ARTICLE_TIME_LINE_EVENTS.map((articles, index) => (
                <div key={articles[0].articleTitle}>
                  <div
                    className={`flex justify-center px-[12rem] ${0 === index ? 'mt-64' : 'mt-72'}`}
                  >
                    <HorizontalTimePoint articles={articles} />
                  </div>
                  {index < ARTICLE_TIME_LINE_EVENTS.length - 1 ? (
                    <div className="mx-[12rem] border-0 border-b border-solid border-gray-200 py-64"></div>
                  ) : (
                    <div className="mx-[12rem] border-0 border-b-2 border-solid border-gray-300 py-64"></div>
                  )}
                </div>
              )))}
      </div>
    </div>
  );
};

export default TimeLine;
